export default "__VITE_ASSET__BFQM4buP__"